// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-header-commandbar {
  margin-left: 16px;
  padding-right: 4px;
}
.bolt-header-commandbar .responsive-placeholder {
  margin: 0;
}

.bolt-header-command-item-button {
  margin: 2px;
}

.bolt-header-command-item-button .bolt-button.icon-only {
  padding: 8px;
}

.bolt-header-commandbar-no-right-padding {
  padding-right: 0px;
}

.bolt-header-command-item-separator {
  background-color: rgba(0, 0, 0, 0.20);
  background-color: var(--palette-black-alpha-20,rgba(0, 0, 0, 0.20));
  width: 1px;
  margin: 4px 8px;
}

/*# sourceMappingURL=HeaderCommandBar.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/HeaderCommandBar/HeaderCommandBar.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/HeaderCommandBar/HeaderCommandBar.css"],"names":[],"mappings":"AACA;EACI,iBC2TS;ED1TT,kBC8SQ;AC9SZ;AFEI;EACI,SAAA;AEAR;;AFIA;EACI,WAAA;AEDJ;;AFKA;EACI,YCqSQ;ACvSZ;;AFKA;EACI,kBAAA;AEFJ;;AFKA;EACI,qCC6Fe;ED5Ff,mEAAA;EACA,UAAA;EEFF,eAAe;AACjB;;AAEA,+CAA+C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
